import React, { useState, useEffect } from 'react';
import { MapPin, Clock } from 'lucide-react';
import { getApiUrl } from '../utils/api';

const Booking = () => {
  const [businessInfo, setBusinessInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const apiUrl = getApiUrl();
        const response = await fetch(`${apiUrl}/api/business-info`);
        const data = await response.json();
        setBusinessInfo(data);
      } catch (error) {
        console.error('Error fetching business info:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchBusinessInfo();
  }, []);

  const locations = [
    {
      name: 'Baldwin',
      address: 'Baldwin, NY',
      hours: 'Wednesday - Saturday: 11:00 AM - 10:00 PM',
      bookingUrl: businessInfo?.baldwin_booking_url || 'https://theslaystationny.glossgenius.com/',
    },
    {
      name: 'Home Studio Islandia',
      address: 'Islandia, NY',
      hours: 'Monday & Tuesday: 5:00 PM - 10:00 PM',
      bookingUrl: businessInfo?.islandia_booking_url || 'https://theslaystationny.glossgenius.com/services',
    },
  ];

  const handleBooking = (location) => {
    window.open(location.bookingUrl, '_blank');
  };

  if (loading) {
    return (
      <div className="booking-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p style={{ color: '#b8860b', fontStyle: 'italic', fontSize: '1.2rem' }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="booking-page">
      <section className="booking-hero">
        <div className="marble-overlay"></div>
        <div className="container">
          <h1 className="hero-medium">Book Your Appointment</h1>
          <p className="body-large">Choose your preferred location and schedule your transformation</p>
        </div>
      </section>

      <section className="booking-content section-padding">
        <div className="container">
          <div className="booking-locations">
            {locations.map((location, index) => (
              <div key={index} className="booking-card">
                <div className="booking-card-content">
                  <h2 className="heading-2">{location.name}</h2>
                  <div className="booking-details">
                    <div className="booking-detail-item">
                      <MapPin size={20} className="detail-icon" />
                      <span>{location.address}</span>
                    </div>
                    <div className="booking-detail-item">
                      <Clock size={20} className="detail-icon" />
                      <span>{location.hours}</span>
                    </div>
                  </div>
                  <button 
                    className="select-button-gold booking-btn-gold"
                    onClick={() => handleBooking(location)}
                  >
                    BOOK NOW
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="booking-info">
            <h3 className="heading-3">Booking Information</h3>
            <div className="gold-divider"></div>
            <ul className="booking-info-list">
              <li>A card on file is required for all appointments; select services may require a deposit</li>
              <li>Cancellations must be made 24 hours in advance</li>
              <li>First-time clients receive a complimentary consultation</li>
              <li>Arrive 10 minutes early to complete any necessary paperwork</li>
              <li>Contact us directly for group bookings or special events</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Booking;
